import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import { Email, Phone, LocationOn } from "@material-ui/icons";
import { Link } from "react-router-dom";
import OpenMap from "./Map";
import { withTranslation } from "react-i18next";

const styles = (theme) => ({
    footer: {
        flexGrow: 1,
        backgroundColor: "rgba(242,234,177,.8)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        marginTop: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 3,
    },
    paper: {
        padding: theme.spacing.unit * 4,
        backgroundColor: "rgba(255,255,255,0.7)",
        height: 260,
    },
    menuButton: {
        marginTop: theme.spacing.unit,
        textTransform: "none",
    },
});

class Footer extends Component {
    render() {
        const { classes, t } = this.props;

        return (
            <div className={classes.footer}>
                <Grid container spacing={8} alignItems="flex-start" justify="center">
                    {/* Static Menu Section */}
                    <Grid item xs={12} md={2}>
                        <Typography align="center" color="primary" component="p">
                            {t("menu")}
                        </Typography>
                        <Divider />

                        {/* Replace dynamic menu with static links */}
                        <Button
                            variant="text"
                            fullWidth
                            className={classes.menuButton}
                            component={Link}
                            to="/"
                        >
                            {t("home")} {/* e.g. Начало */}
                        </Button>

                        <Button
                            variant="text"
                            fullWidth
                            className={classes.menuButton}
                            component={Link}
                            to="/article/5"
                        >
                            {t("about")} {/* e.g. За нас */}
                        </Button>

                        <Button
                            variant="text"
                            fullWidth
                            className={classes.menuButton}
                            component={Link}
                            to="/jobs"
                        >
                            {t("announcements")} {/* e.g. Обяви */}
                        </Button>

                        <Button
                            variant="text"
                            fullWidth
                            className={classes.menuButton}
                            component={Link}
                            to="/jobs/contests"
                        >
                            {t("competitions")} {/* e.g. Конкурси */}
                        </Button>

                        <Button
                            variant="text"
                            fullWidth
                            className={classes.menuButton}
                            component={Link}
                            to="/jobs/scholarships"
                        >
                            {t("scholarships")} {/* e.g. Стипендии */}
                        </Button>

                        <Button
                            variant="text"
                            fullWidth
                            className={classes.menuButton}
                            component={Link}
                            to="/article/678"
                        >
                            {t("documents")} {/* e.g. Документи */}
                        </Button>

                        <Button
                            variant="text"
                            fullWidth
                            className={classes.menuButton}
                            href="https://unwe.bg"
                        >
                            UNWE.bg
                        </Button>
                    </Grid>

                    {/* Contacts */}
                    <Grid item xs={12} md={3}>
                        <Paper className={classes.paper}>
                            <Typography color="primary" component="p">
                                {t("contacts")}
                            </Typography>
                            <Divider />
                            <Typography color="textPrimary" component="p">
                                {t("address")}
                            </Typography>
                            <Typography color="textPrimary" component="p">
                                <LocationOn /> {t("location")}
                            </Typography>
                            <Typography color="textPrimary" component="p">
                                <Phone /> 02 / 8195 278
                            </Typography>
                            <Typography color="textPrimary" component="p">
                                <Email /> iccd1@unwe.bg
                            </Typography>
                            <Typography color="textPrimary" component="p">
                                <a href="https://www.facebook.com/ICCD.UNWE/" target="_blank" rel="noreferrer">
                                    <img src="/img/facebook.png" width="48" alt="Facebook" />
                                </a>
                                <a href="https://www.instagram.com/iccd.unwe/" target="_blank" rel="noreferrer">
                                    <img src="/img/instagram.png" width="48" alt="Instagram" />
                                </a>
                                <a href="https://twitter.com/IccdUnwe" target="_blank" rel="noreferrer">
                                    <img src="/img/twitter.png" width="48" alt="Twitter" />
                                </a>
                                <a href="https://www.linkedin.com/school/unwebg" target="_blank" rel="noreferrer">
                                    <img src="/img/linkedin.png" width="48" alt="LinkedIn" />
                                </a>
                            </Typography>
                        </Paper>
                    </Grid>

                    {/* Map */}
                    <Grid item xs={12} md={3}>
                        <Paper>
                            <OpenMap />
                        </Paper>
                    </Grid>

                    {/* Facebook Widget */}
                    <Grid item xs={12} md={3}>
                        <div
                            className="fb-page location"
                            data-href="https://www.facebook.com/ICCD.UNWE/"
                            data-tabs="timeline,message"
                            data-width="400"
                            data-height="260"
                            data-small-header="true"
                            data-adat-container-width="true"
                            data-hide-cover="false"
                            data-show-facepile="true"
                        >
                            <blockquote
                                cite="https://www.facebook.com/ICCD.UNWE/"
                                className="fb-xfbml-parse-ignore"
                            >
                                <a href="https://www.facebook.com/ICCD.UNWE/">
                                    ICCD UNWE
                                </a>
                            </blockquote>
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation()(Footer));



//import React, { Component } from "react";
//import { connect } from "react-redux";
//import PropTypes from "prop-types";
//import { withStyles } from "@material-ui/core/styles";
//import Typography from "@material-ui/core/Typography";
//import Button from "@material-ui/core/Button";
//import Grid from "@material-ui/core/Grid";
//import Paper from "@material-ui/core/Paper";
//import { Email, Phone, LocationOn } from "@material-ui/icons";
//import { LinkContainer } from "react-router-bootstrap";
//import { bindActionCreators } from "redux";
//import { menuActionCreators } from "../actions/menuActionCreators";
//import Divider from "@material-ui/core/Divider";
//import OpenMap from "./Map";
//import { withTranslation } from "react-i18next"; // Import withTranslation

//const styles = (theme) => ({
//    footer: {
//        flexGrow: 1,
//        backgroundColor: "rgba(242,234,177,.8)",
//        backgroundRepeat: "no-repeat",
//        backgroundSize: "cover",
//        marginTop: theme.spacing.unit * 3,
//        padding: theme.spacing.unit * 3,
//    },
//    grow: {
//        flexGrow: 2,
//    },
//    paper: {
//        padding: theme.spacing.unit * 4,
//        backgroundColor: "rgba(255,255,255,0.7)",
//        height: 260,
//    },
//    externalLink: {
//        color: theme.palette.primary.main,
//    },
//});

//class Footer extends Component {
//    constructor(props) {
//        super(props);
//        this.state = {
//            fixed: false,
//        };
//    }

//    componentDidMount() {
//        this.props.requestMenuElements("main");
//    }

//    render() {
//        const { classes, t } = this.props; // Destructure t from props

//        return (
//            <div className={classes.footer}>
//                <Grid container spacing={8} alignItems="flex-start" justify="center">
//                    <Grid item xs={12} md={2}>
//                        <Typography align="center" color="primary" component="p">
//                            {t("menu")} {/* Translate "Меню" */}
//                        </Typography>{" "}
//                        <Divider />
//                        {this.props.elements.map((element) =>
//                            element.id == 3 || element.id == 4 || element.id == 5 ? (
//                                <Button
//                                    key={element.id}
//                                    variant="text"
//                                    fullWidth
//                                    className={classes.menuButton}
//                                    href={element.link}
//                                >
//                                    {element.title}
//                                </Button>
//                            ) : (
//                                <LinkContainer
//                                    key={element.id}
//                                    to={
//                                        element.articleId !== null
//                                            ? `/article/${element.articleId}`
//                                            : element.link
//                                    }
//                                >
//                                    <Button variant="text" fullWidth className={classes.menuButton}>
//                                        {element.title}
//                                    </Button>
//                                </LinkContainer>
//                            )
//                        )}
//                    </Grid>
//                    <Grid item xs={12} md={3}>
//                        <Paper className={classes.paper}>
//                            <Typography color="primary" component="p">
//                                {t("contacts")} {/* Translate "Контакти" */}
//                            </Typography>{" "}
//                            <Divider />
//                            <Typography color="textPrimary" component="p">
//                                {t("address")} {/* Translate "Междууниверситетски център за развитие на кариерата на УНСС" */}
//                            </Typography>
//                            <Typography color="textPrimary" component="p">
//                                <LocationOn /> {t("location")} {/* Translate "1700 София, район \"Студентски\", ул. \"8-и декември\" 19, каб. 1008" */}
//                            </Typography>
//                            <Typography color="textPrimary" component="p">
//                                <Phone /> 02 / 8195 278
//                            </Typography>
//                            <Typography color="textPrimary" component="p">
//                                <Email /> iccd1@unwe.bg
//                            </Typography>
//                            <Typography color="textPrimary" component="p">
//                                <a href="https://www.facebook.com/ICCD.UNWE/" target="_blank">
//                                    <img src="/img/facebook.png" width="48" />
//                                </a>
//                                <a href="https://www.instagram.com/iccd.unwe/" target="_blank">
//                                    <img src="/img/instagram.png" width="48" />
//                                </a>
//                                <a href="https://twitter.com/IccdUnwe" target="_blank">
//                                    <img src="/img/twitter.png" width="48" />
//                                </a>
//                                <a href="https://www.linkedin.com/school/unwebg" target="_blank">
//                                    <img src="/img/linkedin.png" width="48" />
//                                </a>
//                            </Typography>
//                        </Paper>
//                    </Grid>
//                    <Grid item xs={12} md={3}>
//                        <Paper>
//                            <OpenMap />
//                        </Paper>
//                    </Grid>
//                    <Grid item xs={12} md={3}>
//                        <div
//                            className="fb-page location"
//                            data-href="https://www.facebook.com/ICCD.UNWE/"
//                            data-tabs="timeline,message"
//                            data-width="400"
//                            data-height="260"
//                            data-small-header="true"
//                            data-adat-container-width="true"
//                            data-hide-cover="false"
//                            data-show-facepile="true"
//                        >
//                            <blockquote
//                                cite="https://www.facebook.com/ICCD.UNWE/"
//                                className="fb-xfbml-parse-ignore"
//                            >
//                                <a href="https://www.facebook.com/ICCD.UNWE/">
//                                    {t("address")} {/* Translate "Междууниверситетски център за развитие на кариерата на УНСС" */}
//                                </a>
//                            </blockquote>
//                        </div>
//                    </Grid>
//                </Grid>
//            </div>
//        );
//    }
//}

//Footer.propTypes = {
//    classes: PropTypes.object.isRequired,
//    t: PropTypes.func.isRequired, // Add t to propTypes
//};

//export default withStyles(styles)(
//    withTranslation()( // Wrap the component with withTranslation
//        connect(
//            (state) => state.menu,
//            (dispatch) => bindActionCreators(menuActionCreators, dispatch)
//        )(Footer)
//    )
//);


//import React, { Component } from 'react';
//import { connect } from 'react-redux';
//import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
//import Typography from '@material-ui/core/Typography';
//import Button from '@material-ui/core/Button';
//import Grid from '@material-ui/core/Grid';
//import Paper from '@material-ui/core/Paper';
//import { Email, Phone, LocationOn } from '@material-ui/icons';
//import { LinkContainer, Link } from 'react-router-bootstrap';
//import { bindActionCreators } from 'redux';
//import { menuActionCreators } from '../actions/menuActionCreators';
//import Divider from '@material-ui/core/Divider';
//import OpenMap from './Map';


//const styles = theme => ({
//    footer: {
//        flexGrow: 1,
       
//        backgroundColor: 'rgba(242,234,177,.8)',
//        backgroundRepeat: 'no-repeat',
//        backgroundSize: 'cover',
//        //backgroundAttachment: 'fixed',
//        marginTop: theme.spacing.unit * 3,
//        padding: theme.spacing.unit * 3,
//    },
//    grow: {
//        flexGrow: 2
//    },
//    paper: {
//        padding: theme.spacing.unit * 4,
//        backgroundColor: 'rgba(255,255,255,0.7)',
//        height: 260,
//    },
//    externalLink: {
//        color: theme.palette.primary.main,
//    },
//});

//class Footer extends Component {
//    constructor(props) {
//        super(props);
//        this.state = {
//            fixed: false
//        };
//    }

//    componentDidMount() {
//        this.props.requestMenuElements('main');
//    }

//    render() {
//        const props = this.props;
//        const { classes } = props;

//        return (
//            <div className={classes.footer}>
//                <Grid container spacing={8} alignItems="flex-start" justify="center">
//                    <Grid item xs={12} md={2}>
//                        <Typography align="center" color="primary" component="p">
//                            Меню
//                            </Typography> <Divider />
//                        {props.elements.map(element =>
//                            (element.id == 3 || element.id == 4 || element.id == 5) ?
//                                <Button key={element.id} variant="text" fullWidth className={classes.menuButton} href={element.link}>
//                                    {element.title}
//                                </Button> :
//                            <LinkContainer key={element.id} to={element.articleId !== null ? `/article/${element.articleId}` : element.link}>
//                                <Button variant="text" fullWidth
//                                    className={classes.menuButton}>
//                                    {element.title}
//                                </Button>
//                            </LinkContainer>
//                        )
//                    }
//                   </Grid>
//                    <Grid item xs={12} md={3}>
//                        <Paper className={classes.paper}>
//                            <Typography color="primary" component="p">
//                                Контакти
//                            </Typography> <Divider />
//                            <Typography color="textPrimary" component="p">
//                                Междууниверситетски център за развитие на кариерата на УНСС
//                             </Typography>
//                            <Typography color="textPrimary" component="p">
//                                <LocationOn /> 1700 София, район "Студентски", ул. "8-и декември" 19, каб. 1008
//                               </Typography>
//                            <Typography color="textPrimary" component="p">
//                                <Phone /> 02 / 8195 278
//                            </Typography>
//                            <Typography color="textPrimary" component="p">
//                                <Email /> iccd1@unwe.bg
//                            </Typography>
//                            <Typography color="textPrimary" component="p">
//                                <a href="https://www.facebook.com/ICCD.UNWE/" target="_blank"><img src="/img/facebook.png" width="48" /></a>
//                                <a href="https://www.instagram.com/iccd.unwe/" target="_blank"><img src="/img/instagram.png" width="48" /></a>
//                                <a href="https://twitter.com/IccdUnwe" target="_blank"><img src="/img/twitter.png" width="48" /></a>
//                                <a href="https://www.linkedin.com/school/unwebg" target="_blank"><img src="/img/linkedin.png" width="48" /></a>
//                            </Typography>
//                        </Paper>
//                    </Grid>
//                    <Grid item xs={12} md={3}>
//                        <Paper>
//                            <OpenMap/>
//                        </Paper>
//                    </Grid>
//                    <Grid item xs={12} md={3}>
//                        <div className="fb-page location" data-href="https://www.facebook.com/ICCD.UNWE/" data-tabs="timeline,message" data-width="400" data-height="260" data-small-header="true"
//                            data-adat-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/ICCD.UNWE/" className="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/ICCD.UNWE/">Междууниверситетски център за развитие на кариерата на УНСС</a></blockquote></div>
//                    </Grid>
//                </Grid>
//            </div>
//        );
//    }
//}

////Footer.propTypes = {
////    classes: PropTypes.object.isRequired,
////};

//export default withStyles(styles)(connect(
//    state => state.menu,
//    dispatch => bindActionCreators(menuActionCreators, dispatch)
//)(Footer));